import { CaretIcon, ModalCloseButton, Select } from '@frabbit/react-responsive-select';
import EditorOutput from '@/components/common/EditorOutput';
import { Container } from '@/components/ui/Grid';
import MotionHeader from '@/components/ui/MotionHeader';
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './vacancies.module.scss';
import location_img from './location.svg?url';
import Modal from '@/components/Modal';
import Form from './Form';
import { useTranslation } from 'next-i18next';

const variants = {
  initial: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 1.3,
      delay: 1,
    },
  },
  hidden: { opacity: 0 },
};

const Vacancies = ({ data = { vacancies: [] } }) => {
  const [vacancies, setVacancies] = useState(data.vacancies);
  const [cities, setCities] = useState([]);
  const [current, setCurrent] = useState(null);
  const [modal, setModal] = useState(null);
  const { t } = useTranslation(['common', 'vacancy']);

  useEffect(() => {
    if (current === null || current === 'null') {
      setVacancies(data.vacancies);
    } else {
      const filteredVacancies = data.vacancies.filter(v => v.city.id === current);
      setVacancies(filteredVacancies);
    }
  }, [current]);

  useEffect(() => {
    const filteredCities = vacancies.map(v => v.city);
    setCities(filteredCities);
  }, [vacancies]);

  const options = [
    { value: 'null', text: t('Все города') },
    ...cities.map(c => {
      return { value: c.id, text: c.title };
    }),
  ];

  return (
    <Container>
      {data.title && <MotionHeader>{data.title}</MotionHeader>}
      {data.text && <EditorOutput data={data.text} />}
      {modal && (
        <Modal close={() => setModal(null)}>
          <Form vacancy={modal} />
        </Modal>
      )}
      <motion.div
        className={styles.vacanciesWrapper}
        initial="initial"
        animate="visible"
        exit="hidden"
        variants={variants}
      >
        <div className={styles.vacancies}>
          {vacancies.map(v => {
            return (
              <div key={v.id} className={styles.vacancy}>
                <div className={styles.header}>{v.title}</div>
                <div className={styles.city}>
                  <img src={location_img} height="32" />
                  <span>{v.city.title}</span>
                </div>

                {v.text && (
                  <div className={styles.text}>
                    <EditorOutput data={v.text} animation={false} />
                  </div>
                )}
                <div className={styles.actions}>
                  {v.link && (
                    <a
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className={styles.button}
                      href={v.link}
                    >
                      {t('Откликнуться на hh.ru')}
                    </a>
                  )}
                  <button onClick={() => setModal(v.id)} className={styles.button}>
                    {t('Откликнуться')}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        {options && options.length >= 2 && (
          <div className={styles.select}>
            <Select
              name="city"
              modalCloseButton={<ModalCloseButton />}
              options={options}
              caretIcon={<CaretIcon />}
              selectedValue="null"
              onChange={c => setCurrent(c.value)}
            />
          </div>
        )}
      </motion.div>
    </Container>
  );
};

export default Vacancies;
